import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import TemperatureViewModel from "@/models/TemperatureViewModel";
import TemperatureSensorViewModel from "@/models/TemperatureSensorViewModel";
export default function () {
    const get = async (): Promise<TemperatureViewModel> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.get(`/api/temperature`)
                .then((result: AxiosResponse<TemperatureViewModel>) => {
                    if (result.status === 200) {
                        resolve(result.data);
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };

    const getSources = async (): Promise<TemperatureSensorViewModel[]> => {
        await defineHeaderAxios();
        const result: AxiosResponse<TemperatureSensorViewModel[]> = await Axios.get(
            `/api/temperature/sources`
        );
        return Array.isArray(result.data) ? result.data : [];
    };

    const setSource = async (attachedDeviceId: string): Promise<void> => {
        await defineHeaderAxios();
        await Axios.put(`/api/temperature/source/${encodeURIComponent(attachedDeviceId)}`);
    };

    return {
        get,
        getSources,
        setSource,
    };
}
